import { render } from "./ContactUsModal.vue?vue&type=template&id=3991aca7&scoped=true&ts=true"
import script from "./ContactUsModal.vue?vue&type=script&lang=ts"
export * from "./ContactUsModal.vue?vue&type=script&lang=ts"

import "./ContactUsModal.vue?vue&type=style&index=0&id=3991aca7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3991aca7"]])

export default __exports__